import { render, staticRenderFns } from "./OpenLinkDoctor.vue?vue&type=template&id=16560d3a&"
import script from "./OpenLinkDoctor.vue?vue&type=script&lang=js&"
export * from "./OpenLinkDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports